import { render } from "./DashboardCanalVenta.vue?vue&type=template&id=f35295f4&scoped=true"
import script from "./DashboardCanalVenta.vue?vue&type=script&lang=js"
export * from "./DashboardCanalVenta.vue?vue&type=script&lang=js"

import "./DashboardCanalVenta.vue?vue&type=style&index=0&id=f35295f4&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f35295f4"]])

export default __exports__